var map = {
	"./RCLOUDPHX_headerlogo.svg": 94867,
	"./RUNMYBOT_headerlogo.svg": 31740,
	"assetts/images/RCLOUDPHX_headerlogo.svg": 94867,
	"assetts/images/RUNMYBOT_headerlogo.svg": 31740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60677;